import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Endpoints {
  public urlCreateCargo = "cargo";
  public urlCreateRequest = "cargo/request";
  public updateCargo = "cargo/update";
  public updateRequest = "cargo/request/update";
  public urlCargoList = "cargo?";
  public cargoDispatchStates = "catalog/dispatch-states";
  public updateDispatchState = "cargo/%s/change-state-dispatch";
  public cargoMapPositions = "cargo/tracking/map";
  public urlPreBill = "cargo/preBill";
  public urlCargoListTravelExpenses = "cargo/travel-expenses/filter";
  public urlEnturnamiento = "cargo/takeTurn";
  public fulFillCargosRndc = "cargo/approval/retry-fulfillment";
  public urlCargoListToPay = "cargo/list/toPay?";
  public urlCargoListNegotiation = "cargo/negotiation/";
  public urlCargoRequestListNegotiation = "cargo/negotiation/company/list";
  public urlAcceptCargo = "cargo/negotiate?action=Accepted";
  public urlRefuseCargo = "cargo/negotiate?action=Refuse";
  public urlNegotiateCargo = "cargo/negotiate?action=Negotiate";
  public urlNegotiateRequestSubCompany = "cargo/negotiate/company?action=";
  public getVehicleNegotiations = "cargo/negotiations/vehicles";
  public negotiationsVehiclesOffers = "cargo/negotiations/vehicles/offers/";
  public enrichVehicleNegotiationOffers = "cargo/negotiations/vehicles/offers/enrichment";
  public urlCancelCargo = "cargo/cancel";
  public urlRemoveCargo = "cargo/delete?cargoId=";
  public urlValidateRequestCargo = "cargo/request/validate?id=";
  public urlUpdateOnlyRequest = "cargo/update/set";
  public changeTransportCompany = "cargo/%s/transport-company";
  public transportCompanyChangeJob = "cargo/transport-company/change/%s";
  public sendReport = "cargo/send/reports/";
  public billXML = "cargo/rndc/bill";
  public registerPaymentCargo = "cargo/payments/register";
  public deletePaymentCargo = "cargo/payment?"
  public shippingCostModify = "cargo/shippingCost/modify";
  public createModify = "catalog/modification";
  public approvedCargo = "cargo/approval?";
  public approvedCargoBalance = "cargo/approval/balance?";
  public cashedCargo = "cargo/cashed";
  public updatecargoFeature = "cargo/cargoFeature/update/";
  public overrideRiskProfile = "cargo/riskProfile/override/";
  public validateVehicleTripRequirement = "cargo/negotiate/tripRequirement";
  public deletedAdditionalCosts = "cargo/additionalcost/deleted";
  public deletedBonusAndDiscounts = "cargo/%s/deleted-modifications";
  public deletedPayments = "cargo/%s/deleted-payments";
  public getFileForPayments = "cargo/payments/generate?paymentType=";
  public paymentBankAccounts = "cargo/payment/bank-accounts";
  public urlCargoPayments = "cargo/%s/payments";
  public cargoPDF = "cargo/createPDF";
  public cargoPublishZone = "cargo/zone";
  public rebuildManifest = "cargo/manifest";

  public confirmDriver = "cargo/approval/vehicle?";
  public inspection = "vehicle/inspection";
  public stateVehicle = "vehicle/state";
  public changeCompany = "cargo/changeCompany?";
  public cargoByConsecutive = "cargo?consecutive=";
  public cargoByManifest = "cargo?manifest=";
  public registerLocation = "cargo/register/locationPoint/";
  // public rebuildMinistry = 'cargo/ministry';
  public cancelManifest = "cargo/manifest/cancel";
  public createAndEmitConsignment = "cargo/consignment/create-and-emit";
  public cancelConsignment = "cargo/consignment/cancel";
  public approvePayBalance = "cargo/update/approveBalance";
  public updateLoadDownload = "cargo/uploadDownload/update/";
  public createRoundedCargo = "cargo/round";
  public getRouteGoogleCargo = "route/google?cargoId=";
  public saveRouteGoogleCargo = "route/saveRouteGoogle";
  public uploadRoute = "route/cargo/upload";
  public cargoLogisticTimes = 'cargo/%s/logistics-times';
  public changeLogisticsTimes = 'cargo/logistic-times';
  public assignLock = "cargo/%s/lock";
  public reduceFreightCost = "cargo/%s/freight-cost/";
  public fingerprintHistoryByType = "cargo/%s/fingerprint-histories";
  public saveFingerprintHistoryIndividual = "cargo/%s/fingerprint-histories/session";

  public addObservation = "cargo/observation/add/";

  public thirdParties = "company/thirdParties";
  public thirdPartiesAddress = "company/thirdParties/address";
  public thirdPartiesUpdate = "company/thirdParties/update";
  public cityValidateLocation = "catalog/cities/validate-location";
  public thirdPartiesAddressUpdateState = "company/thirdParties/address/state";

  public createVehicleDriverOwner = "user/validate";
  public createVehicleOwner = "user/basic-vehicle/validation"
  public validateUser = "user/validateUser";
  public checkValidationUser = "user/check/validate?document=";
  public checkValidationIndividual = "user/validateUser/individual";
  public checkValidationVehicle = "vehicle/check?";
  public urlDetailCompany = "company/";
  public urlDetailUserByDocument = "user/";
  public urlDetailUserClientByDocument = "user/client?document=";
  public configUser = "user/config?email=";
  public getUserPhone = "user/getUserPhone?phone=";
  public urlDetailUserByEmail = "user/getUserEmail?email=";
  public userUploadDocument = "user/upload/document";
  public userActivateAffiliation = "user/activate/affiliation";
  public updateDocumentsUser = "user/documents";
  public updateContactsUser = "user/contacts";
  public getUserAdditionalCertifications = "additional-certifications";
  public urlUpdateCompany = "company/update/set";
  public urlUpdateCompanyRndcCredentials = "company/credentials";
  public urlSetDaysDeactivateVehicle = "company/update/configuration/days";
  public urlSetResume = "company/update/configuration/cvsecurity";
  public updateCompany = "company/update";
  public updateRiskProfileBulk = "company/riskProfile/bulk";
  public urlCreateCompany = "company";
  public urlCreateUser = "user";
  public urlCreateUserClient = "user/client"
  public urlRateCargo = "cargo/score?idCargo=";
  public urlDetailCargo = "cargo/";
  public urlDetailCargoByConsecutive = "cargo/consecutive/";
  public urlImageAddressCargo = "cargo/tracking/images?cargoId=";
  public urlExtraImageAddressCargo = "cargo/tracking/extraImages";
  public urlSetStateAddressTracking = "cargo/tracking?action=";
  public urlUpdateAdrressTracking = "cargo/tracking/images/set";
  public urlGetTracking = "cargo/tracking/"
  public urlUpdateUser = "user/updateUser";
  public urlUpdateUId = "user/updateUId";
  public urlUserClientUpdateTerms = "terms/accept"
  public getAllCompanies = "company/companies";
  public linkServices = "cargo/consolidated/link";
  public unlinkConsolidatedService = "cargo/consolidated/unlink";
  public createConsolidatedCargo = "cargo/consolidated/create";
  public replicateService = "cargo/replicate/%s";
  public getAllTypesGps = "catalog/Gps";
  public getAllTypesGpsLower = "catalog/gps";
  public getGPSProviders = "catalog/gps/providers";
  public createGps = "catalog/create?tableName=Gps";
  public getAllCompaniesChildrens = "company/subCompanies?nit=";
  public deleteCompany = "company";
  public addEmailCompany = "catalog/file?";
  public companyEmails = "company/%s/emails";
  public guideNovelties = "guide/states";
  public addNoveltyToGuide = "company/guideNovelties/add";
  public createRole = "company/rol/create";
  public updateRole = "company/rol/update";
  public getHistoryCompanies = "company/request/total?";
  public getReportHistoryCompanies = "company/reports/service?";
  public updateAlertsAndBlocks = "company/documents/mandatory/update";
  public updateChargeOwnFleet = "company/update/configuration/charge-own-fleet/";
  public updateUseEvidenceToGuides = "company/%s/use-evidence-to-guides";
  public getTrailerList = "vehicle/trailer";
  public getTrailerDetail = "vehicle/trailer/";
  public updateTrailer = "vehicle/trailer/change?licensePlate=";
  public urlCatalog = "catalog";
  public transportCompanyCatalog = "catalog/transport-company";
  public urlCatalogTrailerConfig = "catalog/trailer/configurations";
  public companyAdditionalCost = "company/additional-cost";
  // Servicios adicionales a nivel SaaS (utilidades): sin transportCompanyId.
  public urlWhoToPays = "catalog/whoToPay";
  public labelTags = "catalog/private/CargoLabel";
  public getVehicleAliases = "catalog/vehicle-aliases"
  public addlabelTag = "catalog/private/CargoLabel";
  public updateCargoLabels = "cargo/update/labels?cargoId=";
  public compliments = "company/fulfillment/requirement?";
  public getComplimentTypesCatalog = "catalog/fulfillment/requirement";
  public addPrivateComplimentType = "catalog/private/FulfillmentRequirementTypes";
  public vehicleConfiguration = "vehicle/configuration";
  public cargoCompliments = "cargo/fulfillment/requirement";
  public duplicateCargo = "cargo/duplicate";
  public createTrailer = "vehicle/trailer";
  public listTrailer = "vehicle/trailer?";
  public vehicleChangeDriver = "vehicle/change/driver";
  public updateDocumentsVehicle = "vehicle/documents";
  public updateGpsVehicle = "vehicle/gps";
  public syncSatrackVehicleRegistrationStatus = "satrack-automation/vehicles/%s/status/sync";
  public retrySatrackVehicleGpsLink = "satrack-automation/vehicles/%s/gps-link/retry";
  public satrackGpsProviders = "satrack-automation/gps/providers";
  public bodyWorkType = "BodyWorkType";
  public cargoType = "CargoType";
  public methodPayment = "MethodPayment";
  public containerMeasure = "ContainerMeasure";
  public regimeType = "RegimeType";
  public serviceType = "ServiceType";
  public tripType = "TripType";
  public vehicleType = "vehicleType";
  public vehicleTypeCreation = "VehicleType";
  public disableVehicle = "vehicle/deactivate/";
  public forceVehicleActivation = "vehicle/force-activation/";
  public searchMerchandise = "cargo/commodity/search";
  public getConsignmentPackaging = "catalog/Packages";
  public getConsignmentPackagingMaterials = "catalog/package-materials";
  public getCargoInvoicePDF = "cargo/invoice/pdf";
  public companyTaxes = 'accounting/SIIGO/taxes';
  public companyProductSiigo = 'accounting/SIIGO/products';
  public logisticsTimeReasons = 'catalog/LogisticsTimeReasons';
  public approvedBelowSiceTac = "cargo/approve/below/sicetac?idCargo=";
  public requestAdvance = "cargo/payment/advance/request";
  // public guideState = 'GuideState';

  public calculateDistance = "distance";

  public getGuides = "guide/getGuides?";
  public getGuideFalabella = "guide/getGuides?guideId=";
  public setGuideStateFalabella = "guide/changeGuideState";
  public uploadSimpleGuides = "guide/uploadSimpleGuides";
  public uploadGuides = "guide/uploadGuides";
  public getGuidePDF = "guide/createPDF?guideId=";
  public getMultipleGuidesPDF = "guide/creatPDFMultipleGuides";
  public getMultipleGuides = "guide/multiple";
  public updateGuide = "guide/updateGuide";
  public changeGuideStatusDelete = "guide/changeGuideStatusDelete";

  public cargoConsignments = "cargo/consignment/";
  public consignmentSoftDelete = "cargo/consignment/soft-delete";
  public consignmentUpdateRNDC = "cargo/consignment/update-and-emit";
  public getAllCargoConsignments = "cargo/all-consignments";
  public authorizeCargoWithoutConsignment = "cargo/%s/authorized-without-consignment";
  public authorizeCargoWithoutManifest = "cargo/%s/authorized-without-manifest";
  public cargoPrevalidation = "cargo/%s/prevalidation";
  public getMonitoringCompanies = "catalog/MonitoringCompany";
  public getConsolidationTypes = "catalog/ConsolidationType";
  // Endpoints Collection Points
  public collectionPointList = "guide/collectionPoint";
  public collectionPointCreate = "guide/collectionPoint/create";
  public collectionPointUpdate = "guide/collectionPoint/update";
  public collectionPointDelete = "guide/collectionPoint/delete";

  // Endpoints Admin Users
  public usersList = "user/list";
  public usersClientList = "user/client";
  public getPDFTruora = "user/security-study/pdf";
  public finalizeStudyTruora = "user/state";
  public activateUserClient = "user/role/assign?";
  public activateUser = "user/activate/";
  public forceActivationDriver = "user/activate/score?";
  public deactivateUser = "user/deactivate/";
  public userActivationStates = "user/%s/activation-states";
  public deactivateUserClient = "user/client/deactivate/";

  public urlformContact = "email/formContact";
  public roleDetail = "company/rol?rolId=";
  public rolesCompant = "company/rol/list?";

  // Endpoints segimineto de guias
  public trackguide = "guide/getGuideWithHistory?guideId=";
  public getBasicGuide = "guide/external?guideId=";

  // Files
  public exportMainBases = "guide/generate?type=";
  public companyFile = "company/file/register";
  public getCompanyFile = "company/file/list";

  // Reportes
  public getReports = "cargo/reports?";

  public excelToGuide = "guide/excelToGuide";
  public guideStates = "guide/states";
  public massCreationCargo = "cargo/cargoMultiple";

  // Terms and Conditions (Legacy)
  public terms = "terms";
  public updateTermsUser = "user/updateTerms";
  public termsActive = "terms?state=true";
  public getAllPolicies = `terms?state=true&types=["TermsAndConditions","PrivacyPolicies","PersonalDataPolicy"]`;
  public listTermsAndPoliciesUser = "terms/accept";

  // Legal Documents (New)
  public legalDocuments = "catalog/legal-documents";
  public legalDocumentsRead = "legal-documents";
  public legalDocumentsProducts = "legal-documents/products";
  public legalDocumentsClients = "legal-documents/clients";
  public companiesSaaS = "company/saas";
  public applicationFlows = "catalog/ApplicationFlows";
  public documentVersions = "legal-documents/versions";
  public legalDocumentVersions = "legal-documents";
  public legalDocumentVersionDetail = "legal-documents";
  public legalDocumentVersionCreate = "legal-documents";
  public legalDocumentVersionDeleteFile = "legal-documents";
  public userAcceptances = "legal-documents/acceptances";
  public acceptancesValidateStatus = "legal-documents/acceptances/validate-status";
  public legalDocumentNotifications = "legal-documents/notifications";
  public legalDocumentRules = "legal-documents/rules";
  public legalDocumentRulesResolve = "legal-documents/rules/resolution";
  public legalDocumentRulesResolveAll = "legal-documents/rules/resolution";

  public getNotificationCatalog = "catalog/notifications";
  public rolNotification = "roles/notification";

  // Vehicles
  public getVehiclesByIdFromOwnCompany = "vehicle?id=%s&holderCompany=%s";
  public getVehiclesByOwnCompany = "vehicle/byCompany";
  public getTrailersByCompany = "vehicle/trailers/byCompany";
  public getUsersByCompany = "user/byCompany";
  public getVehiclesFromAllCompanies = "vehicle?";
  public getVehicleFromAllCompanies = "vehicle/";
  public updateVehicleFields = "vehicle/update"
  public updateUserLicenses = "user/%s/driver-license"
  public setVehicleBankAccount = "vehicle/bankAccount";
  public registerBanckAccount = "vehicle/bankAccount/register";
  public registerBank = "vehicle/bankAccount/registerBank?";
  public approveDocumentsVehicle = "vehicle/bankAccount/approval?";
  public updateAdministrator = "vehicle/administrator/update/";
  public updateGps = "vehicle/gps/";
  public getVehicleWeightById = "catalog/vehicle/class?id=";
  public getVehicleInspectionPDF = "vehicle/PDF?";
  public getInspectionQuestions = "catalog/inspection-questions"
  public approveVehicle = "vehicle/activate?type=thirty&licensePlate=";
  public approveVehicleChecklist =
    "vehicle/activate?type=checkList&licensePlate=";
  public vehicleDocumentTypes = "catalog/ImageType";
  public vehicleDocuments = "vehicle/images";
  /* /inspection/approval?approval=true */

  //fleet loyalty
  public getFleetLoyaltyTypes = "catalog/FleetLoyaltyCategories";
  public companyFleetLoyalty = "vehicle/fleet-loyalty";

  //catalog
  public getBanck = "catalog/banks";
  public catalogEmailType = "catalog/emailType";

  //help-desk
  public helpDesk = "helpDesk";

  //builling
  public billingRegister = "cargo/billing/register";

  //modules
  public modules = "user/modules";

  //functionalities
  public functionalities = "user/functionality";
  public functionalitiesByIdModule = "user/functionality/list?";

  //city
  public cities = "catalog/cities";
  public urlUpdatecities = "/update/ica";
  public urlUpdateIndependentCity = "catalog/cities/update"
  public updateMainCity = "catalog/cities/update/subcities";

  //subcities: catalog/cities/{cityId}/subcities (GET, POST) y catalog/cities/{cityId}/main-city (DELETE)
  public citySubcities = "/subcities";
  public cityMainCity = "/main-city";
  public catalogBodywork = "catalog/bodywork";

  //cargo reteica
  public cargoReteica = "cargo/changeReteIca?cityId=";

  //cargo location vehicle
  public getTripAnomaly = "catalog/anomalies";
  public getTripAnomalyByType = "catalog/anomalies/service-type";
  public createTripAnomaly = "cargo/tripAnomaly?cargoId=";
  public updateTripAnomaly = "cargo/update/locationPoint/"
  // Error RNDC
  public fixOwnerMinistry = "user/owner/ministry";
  public fixVehicleMinistry = "vehicle/ministry";
  public fixTrailerVehicleMinistry = "vehicle/trailer/ministry";
  public trailerMinistryRetry = "vehicle/trailer/ministryRetry";
  public fixUserMinistry = "user/ministry";
  public fixUserMinistryByDocument = "user/ministry-by-document";

  // Cost Centers
  // Catálogo de centros de costo de Siigo para asociar a una empresa cliente.
  public costCenters = "accounting/SIIGO/cost-centers";
  //Payment types
  public paymentTypes = "accounting/SIIGO/payment-types";

  // Additional Cost
  public addAdditionalcost = "cargo/additionalcost/add";
  // Edit toPay and/or observation in additional services
  public editAdditionalCost = "cargo/additionalcost/modify/extraInformation?";
  // Modify bonus and discounts in additional services
  public modifyValuesAdditionalCost = "cargo/additionalcost/modify?";
  // Delete additional cost
  public deleteAdditionalcost = "cargo/additionalcost/delete?";
  // Additional Cost Update
  public updateAdditionalcost = "cargo/update/additionalCosts";

  // Advance percentage
  public modifyAdvancePercentaje = "cargo/update/advance/percentage/";
  public downloadCargoTraceability = "cargo/traceability/";

  // SIG
  public companyDocuments: string = "company/documents";
  // Company state
  public companyState = "company/state/%s/change";

  public deleteGPS = "/delete?name=";
  //fast payment
  public fastPayment = "cargo/fast/payment/"

  //delete turn
  public deleteTurn = "cargo/takeTurn/delete?"
  public editTurn = "cargo/takeTurn/update"
  //Cartera
  public urlReceivables = "cargo/receivable?"
  public urlReceivablesCreation = "cargo/receivable/create"
  public urlReceivableApproval = "cargo/receivable/approval?"
  public deleteReceivable = "cargo/receivable?id="
  public urlReceivableTypes = "catalog/ReceivableType"
  public urlReceivableReasons = "catalog/ReceivableReasons"
  public urlCreateReceivableModifications = "cargo/receivable/create/modifications"
  //MONITORING ENDPOINTS
  public logs = "catalog/logs";
  public fingerPrints = "server/requests";

  //RESTART LOAD
  public restartLoad = "cargo/restore?"
  // Planes de ruta
  public listRoutes = 'routeplan';
  public updateCity = 'catalog/cities/update';

  public AuthorizedStopPointsTypes = 'AuthorizedStopPoints';

  public createAuthorizedPoint = 'routeplan/point/authorized';
  public createAuthorizedPointBatch = 'routeplan/point/authorized/batch';
  public updateAuthorizedPoint = 'routeplan/point/authorized/update';
  public getAuthorizedPoints = 'routeplan/point/authorized';
  public activeAuthorizedPoint = 'routeplan/point/authorized/active';
  public deactiveAuthorizedPoint = 'routeplan/point/authorized/deactive';

  public createCriticZone = 'routeplan/critic-zone';
  public updateCriticZone = 'routeplan/critic-zone/update';
  public getCriticZones = 'routeplan/critic-zone';
  public addItineraryCriticZone = 'routeplan/itinerary/%s/critic-zones';
  public removeItineraryCriticZone = 'routeplan/itinerary/%s/critic-zones';

  public createControlPoint = 'routeplan/point/control';
  public createControlPoints = 'routeplan/point/control/batch';
  public updateControlPoint = 'routeplan/point/control/update';
  public deactivateControlPoint = 'routeplan/point/control/deactive';
  public activateControlPoint = 'routeplan/point/control/activate';

  public createRouteItinerary = 'routeplan/itinerary/create';
  public routeItinerary = 'routeplan/itinerary';
  public routeItinerarySelect = 'routeplan/itinerary/select';
  public setCargoPlanItinerary = "cargo/route-plan";
  public cargoJournalPdf = 'cargo/journal/pdf';
  public cargoGenerate = 'cargo/generate/';
  public createThirdPartyBank = 'vehicle/bankAccount/thirdParty';
  public generateAccountingFiles = 'accounting/files';
  public accountingTypes = 'accounting/types';

  // Términos, condiciones y políticas
  public requestTermsAndPoliciesAcceptance = 'terms/request';
  public auxiliaryRequestTermsAndPoliciesAcceptance = '/masive-messages/drivers_registration/send-verification-sms';
  public getReportPDF = 'cargo/reports/PDF';

  //Drivin
  public getSchemes = 'drivin/schema';
  public getStoredFleets = 'drivin/vehicle/fleet';
  public updateFleet = 'drivin/vehicle?fleetName='
  public capacities = 'drivin/capacityMeasure';
  public scenarios = 'drivin/scenario';
  public getClientsFromExcel = 'drivin/order/excel';
  public optimizeScenario = 'drivin/scenario/';
  public getRouteByScenario = 'drivin/scenarioRoute?scenarioToken=';
  public drivinCreateCargos = 'drivin/createCargo/list';

  public monitorState = 'company/gps/monitor';

  public initialFulfillConsignments = 'cargo/consignment/initialFulfill';
  public registerVehicleInMonitor = 'gps/monitorhub/vehicle';

  public cargoMoveAdvance = 'cargo/payment/advance/transfer';
  public travelExpenses = 'cargo/travel-expenses';
  public travelExpensesDetail = 'travel-expenses-detail';

  public validationRules = 'catalog/validation-rule';
  // Authentication
  public validateToken = "auth/validate-token"
  public customToken = "auth/custom-token"

  //Service request
  public urlCargoServiceRequests = "cargo-requests"
  public urlCargoServiceRequestsDetail = "cargo-requests/consecutive"

  // Maintenance
  public vehicleTypeCatalog = "catalog/VehicleType"
  public maintenance = "vehicle/maintenance"
  public maintenanceRecords = "catalog/MaintenanceRecords"
  public typeMaintenances = "catalog/TypeMaintenance"

  //Second driver
  public assignChangeSecondDriver = "cargo/%s/second-driver"
  public activateSecondDriver = "cargo/%s/second-driver/activate"

  // saas config
  public getCompanySaaS = "company/saas/%s"
  public getSaasConfig = "company/saas/%s/settings"
  public saasTransportCompanies = "company/saas/%s/companies"
  public saasTransportCompanyInsuranceInformation = "company/saas/%s/companies/%s/insurance-information"
  public saasConfigurations = "company/saas/%s/configurations"

  public updateShippingCost = "cargo/%s/shipping-cost"

  // Cost center actions
  // Centros de costo de una empresa cliente: listar (GET), asociar o crear (POST) y eliminar (DELETE /{id}).
  public individualCostCenter = "company/%s/cost-centers"
  public assignCostCenterToService = "cargo/%s/cost-center"

  public deleteDiscount = "cargo/%s/modifications/%s"

  public extraDocumentsList = "user/%s/extra-documents"
  public saveBasicInformation = "user/%s/basic-information"

  public basicCheck = "vehicle/%s/basic-check"
  public rndcVehicleCreation = "vehicle/%s/ministry"
  public checkOnlyUser = "user/%s/check"

  public deleteAssignedVehicle = "cargo/%s/assigned-vehicle"

  // Billing configuration
  public listBillingUsers = "accounting/SIIGO/users"
  public listTypeBill = "accounting/SIIGO/document-types?type=FV"
  public listAccountingDocumentTypes = "accounting/SIIGO/document-types?type=CC"
  public updateTypeBillCompany = "company/%s/billing-configuration"
  public cargoQueryableVariables = "catalog/cargo-queryable-variables"
  public companyPreBillFields = "company/%s/pre-bill-fields"
  public updateProductSiigoAdditionalService = "catalog/additional-cost/%s"
  public setInfoUserClient = "user/client/%s"
  public getConsecutive = "accounting/consecutive"
  public updateConsecutive = "accounting/consecutive"

  // Satellite Lock
  public satelliteLock = "satellite-lock"
  public getSatelliteLockTypes = "catalog/SatelliteLockType"
  public satelliteLockInspection = "satellite-lock/inspections";

  // Ministry Monitor (estado canales RNDC)
  public ministryCurrentStatus = "cargo/ministry/status";
  public ministryStatusHistory = "cargo/ministry/status/history";

  // Accial (integración contable)
  public accialVouchersSyncXlsx = "accial/vouchers/sync-xlsx";
  public accialCreditNotesAssociations = "accial/credit-notes/associations";

}
